import styled from "styled-components";

export const AlertTrueWrapper = styled.div`
    //border: 1px solid red;
    background-color: #ea4335;
    text-align: center;
    padding: 5px;
    margin: 5px;
    font-size: 1em;
    color: #fff;
    border-radius: 5px;
    
`;

export const AlertFalseWrapper = styled.div`
    //border: 1px solid red;
    background-color: #2098db;
    text-align: center;
    padding: 5px;
    margin: 5px;
    font-size: 1em;
    color: #fff;
    border-radius: 5px;

`;